import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=a44229d6"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/vercel/path0/components/ui/img.vue').default,Link: require('/vercel/path0/components/ui/link.vue').default,NewsletterInput: require('/vercel/path0/components/ui/newsletterInput.vue').default,Footer: require('/vercel/path0/components/footer.vue').default})
